import BaseService from "../BaseService";

export default class KontingentService extends BaseService {

  constructor() {
    super('kontingent');
  }

  async count(params) {
    return this.search(null, params, 'HEAD')
      .then(res => Number(res.headers.get('x-count')))
  }

  async versenden(kontingent) {
    await this.retrieveBackendUrl()
    return this.checkError(
      fetch(`${this.backendUrl}/${kontingent.id}/versenden`, {
        method: 'PUT',
        cache: 'reload',
        headers: this.getJsonHeader()
      })
    )
  }
}
